<div class="modal-header">
  <h4 class="modal-title pull-left">{{'CONTROL_POINT.CONTROL_POINT' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>


<div class="modal-body">
  <div class="modal-content">

    <form id="controlPointForm" (ngSubmit)="onSubmit()">
      @if (controlPoint) {
        <div class="row mb-2">
          <div class="col-md-12 form-group">
            <label>{{'GLOBAL.ACTIF' | translate}}</label>
            <button type="button" name="selectIsActif" btnCheckbox class="toggle-btn ms-2"
              [ngClass]="controlPointModif.isActif === true ? 'btn-success' : 'btn-danger'"
              [(ngModel)]="controlPointModif.isActif">
              {{ controlPointModif.isActif ? ('GLOBAL.OUI' | translate) : ('GLOBAL.NON' | translate) }}
            </button>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-md-8 form-group">
          <label for="ptName">{{'GLOBAL.NOM'| translate}}</label>
          <input type="text" id="ptName" name="ptName" class="form-control" [(ngModel)]="controlPointModif.name" pattern="[a-zA-Z ]*" (keyup)="checkControlPointName()" />
          @if (erreurControlPointName) {
            <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
          }
        </div>
        <div class="col-md-4 form-group">
          <label for="numeroExpertir">{{'CONTROL_POINT.NUMERO_PT_CONTROL' | translate}} </label>
          <input type="number" id="numeroExpertir" name="numeroExpertir" class="form-control" [(ngModel)]="controlPointModif.numeroPoint" ng-pattern="[0-9]+" (keyup)="checkControlPointNumber()" />
          @if (erreurControlPointNumber) {
            <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
          }
        </div>
      </div>


      <div class="row">
        <div class="col-md-4 form-group">
          <label for="ptName">{{'CONTROL_POINT.PPV' | translate}}: (mm/s)</label>
          <input type="text" id="ppv" name="ppv" class="form-control" [(ngModel)]="controlPointModif.ppv"  />
        </div>
        <div class="col-md-4 form-group">
          <label for="numeroExpertir">{{'CONTROL_POINT.K' | translate}}</label>
          <input type="number" id="k" name="k" class="form-control" [(ngModel)]="controlPointModif.k" />
        </div>
        <div class="col-md-4 form-group">
          <label for="numeroExpertir">{{'CONTROL_POINT.ALPHA' | translate}}</label>
          <input type="number" id="alpha" name="alpha" class="form-control" [(ngModel)]="controlPointModif.alpha"  />
        </div>
      </div>


      <app-epsg-modale [mySite]="site" [myControlPoint]="controlPoint" (invalide)="getCoordInvalide($event)" (epsgSite)="getEPSG($event)" (epsgModif)="isModifEPSG($event)" (coordX)="getCoordX($event)" (coordY)="getCoordY($event)" (coordZ)="getCoordZ($event)"></app-epsg-modale>
      @if (erreurCoord) {
        <div class="custom-alert custom-alert-sm">{{'EPSG.ERREUR_COORD' | translate }}</div>
      }

      @if (erreurApi) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
      }

    </form>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group" role="group">
    <button type="submit" form="controlPointForm" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
    <button *ngIf="controlPoint" type="button" class="btn btn-danger" (click)="showConfirmSuppr()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
  </div>
  <div class="btn-group" role="group">
    <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
  </div>
</div>

<div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.SUPPRIMER' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideModalCancel()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
